import RichTextWrapper from "../../../rte/ExternalApi";
import { Loading } from "../../../components/Loading";
import { useDraftHistoryContentQuery } from "./draftAutosaveHistoryApiSlice";

export default function AutosaveHistoryForDraftContent({
	historyId,
}: {
	historyId: number | undefined;
}) {
	// Initialization
	if (!historyId) return null;
	const contentResult = useDraftHistoryContentQuery({
		historyId: historyId,
	});

	return (
		<div className="mt-2 autosave-history-text-content-editor">
			<Loading loading={contentResult.isLoading} className="m-0!" />
			{contentResult.data && (
				<RichTextWrapper
					key={historyId}
					readonly
					initialText={{ text: contentResult.data?.content.trim() ?? "No Essay Entered" }}
				/>
			)}
		</div>
	);
}
